import { render, staticRenderFns } from "./UnArrange.vue?vue&type=template&id=2049d5c4"
import script from "./UnArrange.vue?vue&type=script&lang=js"
export * from "./UnArrange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports